import MarketingSlider from './MarketingSlider';

export default MarketingSlider;
